import { render, staticRenderFns } from "./ScrollComponent.vue?vue&type=template&id=1ba8ca77&scoped=true"
import script from "./ScrollComponent.vue?vue&type=script&lang=js"
export * from "./ScrollComponent.vue?vue&type=script&lang=js"
import style0 from "./ScrollComponent.vue?vue&type=style&index=0&id=1ba8ca77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba8ca77",
  null
  
)

export default component.exports